import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../common/loading";
import { getLocalStorageMenuItem, sendNotificationFirebaseRes } from "../utility";


const MobilePaymentprocessing = ({ tableQr, tableName }) => {

  const mobile_payment_session_id = getLocalStorageMenuItem("mobile_payment_session_id") || "";
  const amount = getLocalStorageMenuItem("amount") || 0;
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const queryString = window.location.search;
  const urlParam = new URLSearchParams(queryString);

  const successVal = params.get("success") || urlParam.get("success") || "";
  const orderId = params.get("order_id") || urlParam.get("order_id") || "";
  const [allTreeData, setAllTreeData] = useState(() => {
    const savedTreeData = getLocalStorageMenuItem("tree_data");
    return savedTreeData ? savedTreeData : [];
  });


  const checkPaySuccess = async () => {
    if (successVal === "true" || successVal === "1") {
      await sendNotificationFirebaseRes(allTreeData?.details, "New Order", "New order has been created", "orders");

      navigate(`/${tableName}/${tableQr}/order_thanks?section=0&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}&success=true&order_id=${orderId}`);
    } else {
      navigate(`/${tableName}/${tableQr}/order_thanks?section=0&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}&success=false&order_id=${orderId}`);
    }
  }

  useEffect(() => {
    checkPaySuccess();
  }, []);

  return <Loading />;
};

export default MobilePaymentprocessing;
